module.exports = __webpack_public_path__ + "static/media/sultron.53aef9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/preventiva/sultron.png
// module id = 1551
// module chunks = 3